// extracted by mini-css-extract-plugin
module.exports = {"searchBarContent":"styles__searchBarContent___2os3v"};